import { store } from '../../app/store'
import { actionsApiSlice } from '../actions/actionsApiSlice'
import { usersApiSlice } from '../users/usersApiSlice';
import { tasksApiSlice } from '../tasks/tasksApiSlice'
import { groupsApiSlice } from '../groups/groupsApiSlice'
import { responsesApiSlice } from '../responses/responsesApiSlice';
import { companiesApiSlice } from '../companies/companiesApiSlice';

import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
const Prefetch = () => {
    const {isAdmin, isTeacter} = useAuth(); 
    useEffect(() => {
       if(isAdmin || isTeacter){
            store.dispatch(usersApiSlice.util.prefetch('getUsers', 'usersList', { force: true }))
            store.dispatch(companiesApiSlice.util.prefetch('getCompanies', 'companiesList', { force: true })) 
       }

        store.dispatch(usersApiSlice.util.prefetch('getProfile', 'profile', { force: true }))
        store.dispatch(groupsApiSlice.util.prefetch('getGroups', 'groupsList', { force: true }))
        store.dispatch(tasksApiSlice.util.prefetch('getTasks', 'tasksList', { force: true }))
        //store.dispatch(actionsApiSlice.util.prefetch('getActions', 'actionsList', { force: true }))
        //store.dispatch(responsesApiSlice.util.prefetch('getResponses', 'responsesList', { force: true }))

    }, [isAdmin, isTeacter])

    return <Outlet />
}
export default Prefetch
